<template>
  <span class="tenant-sidebar-item-content">
    <svg-icon
      v-if="icon"
      class="tenant-sidebar-item-icon"
      :iconName="icon"
    />
    <span
      v-else-if="reserveIconSpace"
      class="tenant-sidebar-item-icon-placeholder"
      aria-hidden="true"
    />
    <span class="tenant-sidebar-item-title">
      <template v-if="title">{{ title }}</template>
      <slot v-else />
    </span>
  </span>
</template>

<script>
export default {
  name: 'TenantSidebarItemContent',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    reserveIconSpace: {
      type: Boolean,
      default: false
    }
  }
}
</script>
